/**
 * 高级检索路由
 * 2017-12-4
 * Bai.Zhiming
 */
'use strict';
angular.module('resAdvancedSearchRouterModule', ['seniorResultsSearchModule'])
    .config(['$stateProvider', function($stateProvider) {
        $stateProvider.state('resadvancedsearch', {
            url: '/resadvancedsearch',
            views: {
                '': {
                    template: '<div ui-view="head"></div><div class="view_body" ui-view="main"></div>',
                },
                'head@resadvancedsearch': {
                    templateUrl: './header_tpl.html',
                    controller: 'HeaderController'
                },
                'main@resadvancedsearch': {
                    templateUrl: './resourceCenter/resAdvancedSearch/resAdvancedSearch_tpl.html',
                    controller: 'resAdvancedSearchCtrl'
                }
            }
        }).state('seniorResults', {
            url: '/seniorResults?rightsData',
            views: {
                '': {
                    template: '<div ui-view="head"></div><div class="view_body" ui-view="main"></div>',
                },
                'head@seniorResults': {
                    templateUrl: './header_tpl.html',
                    controller: 'HeaderController'
                },
                'main@seniorResults': {

                    templateUrl: './resourceCenter/resAdvancedSearch/seniorResults/seniorResults_tpl.html',
                    controller: 'seniorResultsCtrl'
                }

            }

        });
    }]);
